import { connect } from 'react-redux'
import {
  toggleUserProfile,
  toggleSettings,
  setSelectedNode,
  setUnpinNode,
  setGlobalFilterValues,
  resetGlobalFilterValues,
  setIsGlobalFilterOpen,
  setMapLayer
} from '@/store/actions/appSettings'
import { requestGetAlarmsCount, endGetAlarmsCountNotification } from '@/store/actions/alarmManager/getAlarmsCount'
import {
  getProfileOpenState,
  getSettingsOpenState,
  getUserData,
  getNode,
  getPinnedNode,
  getGlobalFilters,
} from '@/store/selectors/appSettings'
import { getSyncInProgress } from '@/store/selectors/integrations'
import { getEventsNewCount, getEventsCountNotification } from '@/store/selectors/alarmManager'
import HeaderPageMobile from './component'
import { setStatusTypes } from '@/store/actions/alarmManager'
import { requestGetAllConnectedIntegrations } from '@/store/actions/dictionaries/connectedIntegrations'
import { getConnectedIntegrationsOptions } from '@/store/selectors/dictionaries/connectedIntegrations'
import {
  getSearchFieldsOptionsData,
  getSearchFieldsOptionsLoading
} from '@/store/selectors/dictionaries/searchFieldsOptions'
import { requestGetSearchFieldsOptions } from '@/store/actions/dictionaries/searchFieldsOptions'

export default connect(
  (state) => ({
    isProfileOpen: getProfileOpenState(state),
    isSettingsOpen: getSettingsOpenState(state),
    syncInProgress: getSyncInProgress(state),
    eventsCount: getEventsNewCount(state),
    eventsCountNotification: getEventsCountNotification(state),
    user: getUserData(state),
    selectedNode: getNode(state),
    pinnedNode: getPinnedNode(state),
    globalFiltersValues: getGlobalFilters(state),
    searchFieldsOptions: getSearchFieldsOptionsData(state),
    searchFieldsOptionsLoading: getSearchFieldsOptionsLoading(state),
    connectedIntegrations: getConnectedIntegrationsOptions(state),
  }),
  (dispatch) => ({
    onToggleProfile: (state) => dispatch(toggleUserProfile(state)),
    onToggleSettings: (state) => dispatch(toggleSettings(state)),
    onGetAlarmsCount: (tenantId) => dispatch(requestGetAlarmsCount(tenantId)),
    endGetAlarmsCountNotification: (tenantId) => dispatch(endGetAlarmsCountNotification(tenantId)),
    onSetSelectedNode: (node) => dispatch(setSelectedNode(node)),
    onSetUnpinNode: (node) => dispatch(setUnpinNode(node)),
    onSetGlobalFilterValues: (values) => dispatch(setGlobalFilterValues(values)),
    onResetGlobalFilterValues: () => dispatch(resetGlobalFilterValues()),
    onSetIsGlobalFilterOpen: () => dispatch(setIsGlobalFilterOpen()),
    setStatusTypes: (payload) => dispatch(setStatusTypes(payload)),
    requestGetSearchFieldsOptions: (payload) => dispatch(requestGetSearchFieldsOptions(payload)),
    requestGetAllConnectedIntegrations: (payload) => dispatch(requestGetAllConnectedIntegrations(payload)),
    setMapLayer: (payload) => dispatch(setMapLayer(payload)),
  }),
)(HeaderPageMobile)
